<template>
    <div v-if="json" class="social-links">
        <template v-for="(socialItem, index) in json.contact.social">
            <div v-if="socialItem" :key="`social${index}`" :class="`socicon-holder ${index}`">
                <!-- Iterate over each social media platform (e.g., facebook, instagram) -->
                <a

                    :key="`link-${index}`"
                    :class="`socicon-a zlink-underline-leftright-${themeColor} ${index}`"
                    :href="socialItem.link"
                    target="_blank"
                    :aria-label="socialItem.type"
                >
                    <!-- Load SVG based on platform name -->
                    <component :is="getSvg(socialItem.type)" class="icon-svg" />
                </a>
            </div>
        </template>
    </div>
</template>

<script>
import Bluesky from "@/components/svgs/Bluesky";
import Discord from "@/components/svgs/Discord";
import Facebook from "@/components/svgs/Facebook";
import Instagram from "@/components/svgs/Instagram";
import Linkedin from "@/components/svgs/Linkedin";
import Reddit from "@/components/svgs/Reddit";
import Snapchat from "@/components/svgs/Snapchat";
import Tiktok from "@/components/svgs/Tiktok";
import Twitch from "@/components/svgs/Twitch";
import Twitter from "@/components/svgs/Twitter";
import Youtube from "@/components/svgs/Youtube";

export default {
    name: "SocialComponent",
    props: {
        themeColor: {
            type: String,
            required: false,
            default: 'gray',
        },
    },
    data() {
        return {
            window: window,
            json: null,
        };
    },
    mounted() {
        // Assuming the json comes from global config
        this.json = this.window.config.json.global;
    },
    methods: {
        getSvg(platform) {
            platform = String(platform).toLowerCase();
            switch (platform) {
                case "facebook":
                    return Facebook;
                case "instagram":
                    return Instagram;
                case "twitter":
                case "x":
                    return Twitter;
                case "youtube":
                    return Youtube;
                case "linkedin":
                    return Linkedin;
                case "discord":
                    return Discord;
                case "reddit":
                    return Reddit;
                case "snapchat":
                    return Snapchat;
                case "tiktok":
                    return Tiktok;
                case "twitch":
                    return Twitch;
                case "bluesky":
                    return Bluesky;
                default:
                    return null;
            }
        }
    },
};
</script>
